export default function ButtonWrapper({ children }) {
  return (
    <div className="flex gap-8 flex-col-reverse sm:flex-row justify-center items-center">{children}</div>
  );
}
